import React from 'react';

import sy from '~/styles';
import {Text} from '~/components/controls';
import PropTypes from 'prop-types';

const compareTasksByDuration = (a, b) => {
  if (a.type && !b.type) {
    return -1;
  }

  if (!a.type && b.type) {
    return 1;
  }

  if (a.duration === b.duration) {
    return a.work_text.localeCompare(b.work_text);
  }

  return b.duration - a.duration;
};

const getManualInputOperations = (tasks, rob_components) =>
  Array.from(
    new Set(
      tasks
        .map(
          (task) =>
            rob_components[task.rob_code]?.operations.find(
              (item) => item.operation.code === task.operation,
            )?.operation.description,
        )
        .filter(Boolean),
    ),
  );

const getMaintenanceOperations = (tasks) =>
  tasks.sort(compareTasksByDuration).map((task) => task.work_text ?? 'Invoer');

const buildOperationsSuffix = (operations) =>
  operations?.length > 0 ? (
    <>&nbsp;&middot;&nbsp;{operations.join(', ')}</>
  ) : (
    <></>
  );

const buildNonReferenceContent = ({tasks, rob_components}) => {
  const operations = getManualInputOperations(tasks, rob_components);

  return (
    <>
      Invoer
      {buildOperationsSuffix(operations)}
    </>
  );
};

const buildReferenceContent = ({tasks, is_maintenance_item}) => {
  const main_task = tasks.find((item) => item.is_main_task);
  const type = main_task?.source ?? 'TecRMI';
  const operations = is_maintenance_item
    ? getMaintenanceOperations(tasks)
    : null;

  return (
    <>
      {type}
      {buildOperationsSuffix(operations)}
    </>
  );
};

const buildTaskSubtitleContent = ({
  lessor,
  tasks,
  is_maintenance_item,
  is_sla_item,
  ready,
  rob_components,
}) => {
  if (!ready) {
    return <>Keuze maken</>;
  }

  if (is_sla_item) {
    return <>SLA&nbsp;&middot;&nbsp;{lessor}</>;
  }

  if (tasks.every((item) => !item.reference)) {
    return buildNonReferenceContent({tasks, rob_components});
  }

  return buildReferenceContent({tasks, is_maintenance_item});
};

const TaskSubtitle = ({
  lessor,
  tasks,
  is_maintenance_item,
  is_sla_item,
  ready,
  enabled,
  cancelled,
  cancellation_approved,
  cancellation_denied,
  rob_components,
}) => {
  const content = buildTaskSubtitleContent({
    lessor,
    tasks,
    is_maintenance_item,
    is_sla_item,
    ready,
    rob_components,
  });

  return (
    <Text
      style={[
        sy.truncate,
        sy.small,
        sy['text-lightgray'],
        enabled && sy['underline'],
        (cancelled || cancellation_approved || cancellation_denied) &&
          sy['line-through'],
      ]}>
      {content}
    </Text>
  );
};
TaskSubtitle.propTypes = {
  lessor: PropTypes.any,
  tasks: PropTypes.any,
  is_maintenance_item: PropTypes.any,
  is_sla_item: PropTypes.any,
  ready: PropTypes.any,
  enabled: PropTypes.any,
  cancelled: PropTypes.any,
  cancellation_approved: PropTypes.any,
  cancellation_denied: PropTypes.any,
  rob_components: PropTypes.any,
};

export default TaskSubtitle;
